export default __webpack_public_path__ + "static/media/w3.f145e909.jpg";